import { WRAPPER_TO_GAME_CLIENT_EVENT_TYPES } from '@/features/event-handlers/wrapper-event-handlers/game-client-events/types';

export enum RGI {
  FGP = 'fgp',
  INCENTIVE_GAMES = 'incentive_games',
}

export enum Brand {
  FanDuel = 'fanduel',
  Mohegansun = 'mohegansun',
}

export enum Platform {
  Web = 'web',
  Android = 'android',
  Xsell = 'xsell',
  iOS = 'ios',
  MobileWeb = 'mobile_web',
}

export enum Product {
  Casino = 'casino',
  Xsell = 'xsell',
  Poker = 'poker',
}

export enum Channel {
  Casino = 'CASINO',
  Xsell = 'X-SELL',
  Poker = 'POKER',
}

export enum Provider {
  IGT = 'IGT',
  LNW = 'LNW',
  DGC = 'DGC',
  EVOLUTION = 'EVOLUTION',
  EVERI = 'EVERI',
  HIGH5 = 'HIGH5',
  ARISTOCRAT = 'ARISTOCRAT',
  SPINGAMING = 'SPINGAMING',
  REALMS = 'SLINGO',
  EZUGI = 'EZUGI',
  NETENT = 'NETENT',
  PLAYTECH = 'PLAYTECH',
  PLAYTECH_POKER = 'PLAYTECH_POKER',
  PRAGMATIC = 'PRAGMATIC',
  AWAGER = 'AWAGER',
  FUSION = 'FUSION',
}

export type ProviderType = (typeof Provider)[keyof typeof Provider];

export enum GenericProvider {
  WHITEHAT = 'WHITE_HAT',
  GAMECODE = 'GAMECODE',
  FLUTTERSTUDIOS = 'FLUTTER_STUDIOS',
  AGS = 'AGS',
  GAMINGREALMS = 'GAMING_REALMS',
}

export type State = 'MI' | 'PA' | 'NJ' | 'CT' | 'WV' | 'MR' | 'ON' | 'AB';

export type LauncherEvent<T> = {
  type:
    | typeof WRAPPER_TO_GAME_CLIENT_EVENT_TYPES.INITIALIZE_PARAMS
    | typeof WRAPPER_TO_GAME_CLIENT_EVENT_TYPES.TRIGGER_GEOLOCATION;
  payload: T;
};

export type LaunchParams = {
  rgi?: RGI;
  brand?: Brand;
  provider?: Provider;
  gameStudio?: string;
  gameName?: string;
  providerRef?: string;
  providerRefDesktop?: string;
  providerRefMobile?: string;
  region?: string;
  gameUid?: string;
  userId?: string;
  geocomplyToken?: string;
};

export type HandshakePayload = {
  initializeGameParams: LaunchParams;
  amplitudeEvents: Record<string, unknown>;
  experiments?: Record<string, unknown>;
  iosVersion?: string;
};
